import config from 'config';

const APIConfig = config({});

export { APIConfig };
